export default __webpack_public_path__ + "static/media/logoPng.8ed0ab7f.png";